import { TaskListItem } from '@myapp/contract'
import { ChevronRight, Navigation } from 'lucide-react'

interface Props {
  tasks: TaskListItem[]
  onTaskClick: (taskId: number) => void
}

export const DepartureReminderBanner = ({ tasks, onTaskClick }: Props) => {
  if (tasks.length === 0) return null

  return (
    <div className="flex flex-col gap-1.5 px-3 py-2 bg-amber-50/50 border-b border-amber-100">
      <span className="text-[11px] font-medium text-amber-500 uppercase tracking-wide">
        Abfahrt nachtragen
      </span>
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-2.5 bg-white rounded-lg shadow-sm border border-amber-200 border-l-4 px-3 py-2 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
          style={{ borderLeftColor: '#F59E0B' }}
          onClick={() => onTaskClick(task.id)}
        >
          <Navigation size={15} color="#F59E0B" className="shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800 truncate leading-tight">
              {task.title}
            </p>
          </div>
          <ChevronRight size={15} className="shrink-0 text-gray-400" />
        </div>
      ))}
    </div>
  )
}
